import React from "react";

const LightBulb = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 72 72" fill="none" {...props}>
    <path d="M63 6L60 9M9 6L12 9M63 48L60 45M9 48L12 45M27 54H45M30 63H42M36 9C24 9 17.856 14.85 18 24C18.069 28.461 19.5 31.5 22.5 34.5C25.5 37.5 27 39 27 45H45C45 39 46.5 37.5 49.5 34.5C52.5 31.5 53.931 28.461 54 24C54.144 14.85 48 9 36 9Z" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);


export default LightBulb;